const GCS_ORIGIN = 'https://storage.googleapis.com';
const CDN_ORIGIN = 'https://cdn.lumen5.com';
/** Must stay within the buckets cdn.lumen5.com proxies (lumen5-170819-terraform/cloudflare/main.tf). */
const CDN_BUCKETS = ['lumen5-site-css', 'lumen5-prod-lottie'];

/**
 * The cdn.lumen5.com url for a file in one of our static asset buckets, so it is served from
 * Cloudflare's cache rather than billed as GCS egress. Any other url is returned unchanged.
 * Only rewrite the url being fetched: video data, cache keys and lottie provenance keep the
 * stored url.
 */
export function toCdnUrl(url: string): string {
    let parsed: URL;
    try {
        parsed = new URL(url);
    } catch {
        return url;
    }
    if (parsed.origin !== GCS_ORIGIN) {
        return url;
    }
    const [bucket] = parsed.pathname.replace(/^\//, '').split('/');
    if (!CDN_BUCKETS.includes(bucket)) {
        return url;
    }
    return `${CDN_ORIGIN}${parsed.pathname}${parsed.search}`;
}
